import {
  DoseComponentFormValues,
  emptyDoseComponent,
} from "@/components/dose/dose-form/dose-form-schema";

import { Unit } from "@/types/enums/unit";
import { Medication } from "@/types/medication";

/**
 * Expand a compound medication into one editable dose component per ingredient,
 * prefilling each with the ingredient's default amount/unit/quantity. Falls back to
 * the constituent medication's catalog unit, then MG. Used wherever a compound is
 * selected (dose form row, add-dose prefill, edit-dose prefill).
 */
export function expandCompoundComponents(
  compound: Medication,
  medications: Medication[],
): DoseComponentFormValues[] {
  return compound.ingredients.map((ingredient) => {
    const ingredientMed = medications.find(
      (medication) => medication.id === ingredient.ingredientMedicationId,
    );
    const name = ingredient.ingredientName || ingredientMed?.name || "";
    return {
      ...emptyDoseComponent(name),
      medicationId: ingredient.ingredientMedicationId,
      amount: ingredient.amount ?? 0,
      unit:
        (ingredient.unit as Unit | null) ||
        (ingredientMed?.unit as Unit | null) ||
        Unit.MG,
      quantity: ingredient.quantity ?? 1,
    };
  });
}
